// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3tuXP","orange":"orange--1CZWS","blue":"blue--17Gja","title":"title--3YFzg"};